// Actions
export const SHARE__TRACK_COMPONENT_VIEWED = 'SHARE__TRACK_COMPONENT_VIEWED';
export const SHARE__SHARE_VIA_PLATFORM = 'SHARE__SHARE_VIA_PLATFORM';
export const SHARE__SHARE_VIA_EMAIL = 'SHARE__SHARE_VIA_EMAIL';
// Getters
export const SHARE__CUSTOMER_REFERRAL = 'SHARE__CUSTOMER_REFERRAL';
export const SHARE__PLATFORMS = 'SHARE__PLATFORMS';
export const SHARE__PRIMARY_PLATFORM = 'SHARE__PRIMARY_PLATFORM';
export const SHARE__WIDGET_PLATFORM = 'SHARE__WIDGET_PLATFORM';
// Mutations
export const SHARE__RESET = 'SHARE__RESET';
export const SHARE__MUTATE_LOADING_STATUS = 'SHARE__MUTATE_LOADING_STATUS';
